import { getPayload } from "./http";
/**
* Web3 provider, which can be used with an instance of the Web3 class.
*/

var provider = {
  isProvider: function isProvider(a) {
    var b;
    return (null === a || void 0 === a || null === (b = a.currentProvider) || void 0 === b ? void 0 : b.send) !== void 0;
  },
  send: function send(a, b, c) {
    var d = getPayload(b, c);
    return new Promise(function (b, c) {
      a.currentProvider.send(d, function (a, d) {
        return a ? c(a) : d ? void b(d.result) : c(new Error("No response payload"));
      });
    });
  }
};
export default provider;